import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import * as P from "./Esg-guide-post-styles";
import "react-quill/dist/quill.bubble.css";
import "react-quill/dist/quill.snow.css";
import InquiryCompleteModal from "../../elements/inquiryCompleteModal";
import * as News from "../../newsletter/newsletter.styles";
import { subscribeInsetSet } from "../../../api/subscribe";
import { failAlert, successAlert } from "../../../common/alert";
import SingleProduct from "../../ecommerce/singleProduct/SingleProduct";
import styled from "styled-components";

export const CheckoutBtn = styled.button`
  margin: 0 15px 0 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #3bb77e;
  background-color: #3bb77e;
  color: #fff;
  border-radius: 5px;
  word-break: keep-all;
  font-size: 1rem;
  font-weight: 500;

  :hover {
    background-color: #ffc107;
    border-color: #ffc107;
  }
`;

const DummyBoardsCategory = {
  news: "ESG 환경뉴스",
  letter: "ESG 뉴스레터",
  package: "소재와 포장재",
  make: "제작사례 & 포장재리뷰",
  notice: "공지사항",
};

const Post = ({ initialPostData, postId }) => {
  const router = useRouter();
  const [postData] = useState(initialPostData.current || {});
  const [postNextData] = useState(initialPostData.next || {});
  const [postPrevData] = useState(initialPostData.prev || {});
  const allPosts = React.useMemo(() => {
    const posts = [];

    // 이전 게시물들 추가 (배열)
    if (Array.isArray(postPrevData) && postPrevData.length > 0) {
      postPrevData.forEach((prevPost) => {
        if (prevPost && prevPost.id) {
          posts.push({
            ...prevPost,
            isPrev: true, // 이전 글임을 표시
          });
        }
      });
    }

    // 다음 게시물들 추가 (배열)
    if (Array.isArray(postNextData) && postNextData.length > 0) {
      postNextData.forEach((nextPost) => {
        if (nextPost && nextPost.id) {
          posts.push({
            ...nextPost,
            isNext: true, // 다음 글임을 표시
          });
        }
      });
    }

    return posts;
  }, [postPrevData, postNextData]);

  const [email, setEmail] = useState("");
  const [openInquiryComplete, setOpenInquiryComplete] = useState(false);

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onClickInquiryComplete = () => {
    setOpenInquiryComplete((prev) => !prev);
  };

  const getBackUrl = (gubun) => {
    if (gubun === "notice") return "/csboard/notice";
    if (gubun === "news") return "/esg-guide/news";
    if (gubun === "letter") return "/esg-guide/letter";
    if (gubun === "package" || gubun === "make")
      return `/esg-guide/blog/${gubun}`;
    return "/";
  };

  const subscribe = async () => {
    if (email == "") {
      failAlert("이메일을 입력해주세요.");
      return;
    }
    const body = {
      modes: "InsertSet",
      email: email,
    };
    const res = await subscribeInsetSet(body);
    if (res.Code === "0000") {
      onClickInquiryComplete();
      successAlert(res?.Data?.Msg || "구독 신청이 완료되었습니다.");
      setEmail("");
    } else {
      failAlert(res.Data?.Msg || "구독 신청에 실패했습니다.");
    }
  };

  const isEsgGuide = router.asPath.includes("esg-guide");

  // 페이지 유형에 따라 브레드크럼 데이터 구성
  const breadcrumbData = isEsgGuide
    ? {
        parent: "홈",
        sub: "ESG자료실",
        subTitle: DummyBoardsCategory[postData.gubun],
        subChild: postData?.title,
      }
    : {
        parent: "홈",
        sub: DummyBoardsCategory[postData.gubun],
        subTitle: postData?.title,
        subChild: undefined,
      };

  return (
    <>
      <Layout
        {...breadcrumbData}
        pageTitle={postData?.title}
        pageDesc="칼렛스토어의 ESG자료실에서 지속가능한 패키징과 환경 관련 최신 정보를 확인하세요. 친환경 패키징 트렌드와 정책 소식을 한눈에 볼 수 있습니다."
        pageKeyword="ESG자료실, 칼렛스토어, 지속가능경영, 친환경정보, 패키징트렌드, 환경정책, ESG경영, 친환경소식, 지속가능패키징"
        id={postId}
      >
        <section className="mb-50">
          <div className="container custom">
            <div className="col-lg-12 m-auto">
              <P.Container className="single-page pt-50 ">
                <P.HeaderWrapper className="single-header style-2 mb-0">
                  <div className="row">
                    <div className="col-xl-10 col-lg-12 m-auto border-bottom">
                      <h1 className="mb-30 text-center">{postData?.title}</h1>
                      <P.HeaderMeta className="single-header-meta mb-10">
                        <div className="entry-meta meta-1 mt-10 mb-10">
                          <div className="meta-left">
                            <Link href="#">
                              <a className="author-avatar">
                                <img
                                  className="img-circle"
                                  src="/favicon.svg"
                                  alt="favicon"
                                  style={{ width: "30px" }}
                                />
                              </a>
                            </Link>
                            <span className="post-by">By 칼렛스토어</span>
                            <span className="post-on has-dot">
                              {postData?.wdate}
                            </span>
                          </div>
                          <ul className="meta-right">
                            {/* 공유 버튼 */}
                            <a
                              aria-label="Share"
                              className="action-btn hover-up"
                              onClick={() =>
                                navigator.clipboard
                                  .writeText(globalThis.location.href)
                                  .then(() =>
                                    successAlert("링크가 복사되었습니다.")
                                  )
                              }
                            >
                              <i
                                className="fi-rs-share"
                                style={{
                                  fontSize: "20px",
                                  marginRight: "16px",
                                }}
                              ></i>
                            </a>
                            <Link href={getBackUrl(postData.gubun)}>
                              <li>
                                <a>목록으로</a>
                              </li>
                            </Link>
                          </ul>
                        </div>
                      </P.HeaderMeta>
                    </div>
                    {(postData?.file1 ||
                      postData?.file2 ||
                      postData?.file3) && (
                      <div className="col-xl-10 col-lg-12 m-auto border-bottom p-3 ">
                        <div className="d-flex align-items-center flex-wrap">
                          <div className="me-2">첨부파일 :</div>
                          {postData?.file1 && (
                            <div className="me-2">
                              <a
                                className="text-body"
                                target="_blank"
                                href={postData?.file1}
                              >
                                {postData?.file1_name || "첨부파일 1"}
                              </a>
                              {postData?.file2 && ","}
                            </div>
                          )}
                          {postData?.file2 && (
                            <div className="me-2">
                              <a
                                className="text-body"
                                target="_blank"
                                href={postData?.file2}
                              >
                                {postData?.file2_name || "첨부파일 2"}
                              </a>
                              {postData?.file3 && ","}
                            </div>
                          )}
                          {postData?.file3 && (
                            <div>
                              <a
                                className="text-body"
                                target="_blank"
                                href={postData?.file3}
                              >
                                {postData?.file3_name || "첨부파일 3"}
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </P.HeaderWrapper>
                <P.ContentsWrapper className="single-content mt-30 mb-40">
                  <div className="container">
                    <div className="container">
                      <div className="col-xl-10 m-auto">
                        <P.EditorWrapper>
                          <div
                            className="ck-content"
                            dangerouslySetInnerHTML={{
                              __html: postData?.contents,
                            }}
                          />
                        </P.EditorWrapper>
                      </div>
                    </div>
                  </div>
                </P.ContentsWrapper>

                <div className="col-lg-10 col-xl-10 m-auto">
                  {/* Post list table with title */}
                  <h5 className="text-lg font-medium text-center mb-4 entry-bottom pt-45">
                    '
                    {(postData?.gubun && DummyBoardsCategory[postData.gubun]) ||
                      "그린 여정(旅行)"}
                    '의 다른 글
                  </h5>

                  <div className="rounded overflow-hidden mb-8">
                    <table className="w-full">
                      <tbody>
                        {allPosts.map((post) => (
                          <tr
                            key={post.id}
                            className="border-b border-gray-200 hover:bg-gray-50"
                          >
                            <td className="text-left">
                              <div className="d-flex gap-2">
                                {post.thumbnail && (
                                  <div
                                    className="min-w-[42px] max-w-[42px]"
                                    style={{
                                      width: "42px",
                                      marginTop: "1%",
                                    }}
                                  >
                                    <img
                                      src={post.thumbnail}
                                      alt={post.title}
                                      className="w-full h-auto object-cover rounded"
                                    />
                                  </div>
                                )}
                                <div className="pt-5">
                                  <a
                                    href={`/esg-guide/post/${post.id}`}
                                    className="hover:text-blue-500 font-md truncate"
                                  >
                                    {post.title}
                                  </a>
                                  <p className="text-left font-sm truncate">
                                    {post.summary}
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td className="text-center text-gray-500 whitespace-nowrap w-[120px]">
                              {post.wdate}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Navigation footer - matching your existing markup */}
                  <div
                    className="tags w-sm-100 mb-30 d-flex justify-content-center align-items-center gap-4"
                    style={{ width: "100%" }}
                  >
                    <div className="mx-auto">
                      <CheckoutBtn
                        onClick={() => {
                          router.push(getBackUrl(postData.gubun));
                        }}
                      >
                        목록으로
                      </CheckoutBtn>
                    </div>
                  </div>

                  {postData?.gubun && postData.gubun === "letter" && (
                    <News.Section>
                      <h6>
                        최신 환경정책과 포장재 트렌드, <br />
                        칼렛스토어의 신제품 출시 소식을 가장 먼저 받아보세요!
                      </h6>
                      <img
                        src="/assets/imgs/page/subscribe/icon.png"
                        alt="newsletter_btn"
                        className="icon"
                        style={{ right: "30px" }}
                      />
                      <News.SubscibeWrapper esg={true}>
                        <input
                          onChange={onChangeEmail}
                          type="text"
                          placeholder="이메일을 입력하세요"
                          value={email || ""}
                        />
                        <div onClick={subscribe}>
                          <img src="/assets/imgs/page/subscribe/subscribe_btn.png" />
                        </div>
                      </News.SubscibeWrapper>
                    </News.Section>
                  )}
                  {postData?.products && (
                    <div>
                      <h3 className="section-title style-1 mb-30 mt-50">
                        연관 상품
                      </h3>
                      <P.RecomandList className="product-grid-4">
                        {postData.products.map((product, i) => (
                          <SingleProduct product={product} key={i} index={i} />
                        ))}
                      </P.RecomandList>
                    </div>
                  )}
                </div>
              </P.Container>
            </div>
          </div>
        </section>
      </Layout>
      {openInquiryComplete && (
        <InquiryCompleteModal onClickInquiryComplete={onClickInquiryComplete} />
      )}
    </>
  );
};

export default Post;
